import $const from "@/utils/const";
import router from "@/router";
import SessionService from "@/services/session.service";
import AppService from "@/services/app.service";
import {getField, updateField} from "vuex-map-fields";
import Vue from "vue";

const state = () => ({
    overview: {
        chat_with_bot: 0,
        chat_with_agent: 0
    },
    loading: false,
    selectedChannels: [...Object.values($const.INTEGRATION_CHANNEL)]
});
const mutations = {
    updateField,
    setOverview(state, payload) {
        state.overview = payload
    },
    setLoading(state, payload) {
        state.loading = payload
    }
};
const actions = {
    getOverview({commit}, channels) {
        const botCode = router.currentRoute.params.bot_code
        if (botCode) {
            commit('setLoading', true)
            SessionService.currentSessionOverview(botCode, channels)
                .then(res => {
                    commit('setOverview', res.data)
                })
                .catch(() => {
                    AppService.toastError("Fetch overview current sender session failed")
                })
                .finally(()=> {
                    commit('setLoading', false)
                })
        }
    },
    processNewSessionEvent({state}, session) {
        if (state.selectedChannels.includes(session.channel)) {
            if (session.chat_with === 'bot') {
                Vue.set(state.overview, 'chat_with_bot', state.overview.chat_with_bot +1)
            }
            else {
                Vue.set(state.overview, 'chat_with_agent', state.overview.chat_with_agent +1)
            }
        }
    },
    processEndSessionEvent({state}, session) {
        if (state.selectedChannels.includes(session.channel)) {
            if (session.chat_with === 'bot') {
                Vue.set(state.overview, 'chat_with_bot', state.overview.chat_with_bot -1)
            }
            else {
                Vue.set(state.overview, 'chat_with_agent', state.overview.chat_with_agent -1)
            }
        }
    }
};
const getters = {
    getField,
    concurrentSession(state) {
        const totalChatWithBot = state.overview.chat_with_bot;
        const totalChatWithAgent = state.overview.chat_with_agent;
        const total = totalChatWithBot + totalChatWithAgent;
        if (total > 0) {
            return [
                {
                    label: "Chat with Bot",
                    value: totalChatWithBot,
                    rate: `${((totalChatWithBot / total) * 100).toFixed(2)} %`
                },
                {
                    label: "Chat with Agent",
                    value: totalChatWithAgent,
                    rate: `${((totalChatWithAgent / total) * 100).toFixed(2)} %`
                }
            ]
        }
        return []
    },
    currentSessionTotal(state) {
        return (state.overview.chat_with_bot + state.overview.chat_with_agent).toString()
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
